import { jsx, jsxs } from "react/jsx-runtime";
import { Stack, Box, Text, Heading } from "braid-design-system";
import { JDVLayout } from "./styles/components/JDVLayout/JDVLayout.mjs";
import { JobDetailsPreview } from "./styles/components/JobDetailsPreview/JobDetailsPreview.mjs";
import { JobDetailsView, useJobDetailsProps } from "./styles/components/JobDetailsView/JobDetailsView.mjs";
const paragraph = () => /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
  /* @__PURE__ */ jsx(Box, { background: "neutralLight", borderRadius: "large", width: "full", children: /* @__PURE__ */ jsx(Text, { children: " " }) }),
  /* @__PURE__ */ jsx(Box, { background: "neutralLight", borderRadius: "large", width: "full", children: /* @__PURE__ */ jsx(Text, { children: " " }) }),
  /* @__PURE__ */ jsx(Box, { background: "neutralLight", borderRadius: "large", width: "full", children: /* @__PURE__ */ jsx(Text, { children: " " }) }),
  /* @__PURE__ */ jsx(
    Box,
    {
      background: "neutralLight",
      borderRadius: "large",
      style: { width: "160px", maxWidth: "100%" },
      children: /* @__PURE__ */ jsx(Text, { children: " " })
    }
  )
] });
const JobDetailsMockup = ({
  highlightApplyButton = true,
  showMainContent = true,
  ...props
}) => {
  const applyButtonBackgroundColour = highlightApplyButton ? "brandAccent" : "neutralLight";
  return /* @__PURE__ */ jsx(
    JDVLayout,
    {
      ...props,
      applyAction: /* @__PURE__ */ jsx(
        Box,
        {
          background: applyButtonBackgroundColour,
          borderRadius: "standard",
          height: "touchable",
          children: /* @__PURE__ */ jsx("div", { style: { width: "160px" } })
        }
      ),
      saveAction: /* @__PURE__ */ jsx(
        Box,
        {
          background: "formAccentSoft",
          borderRadius: "standard",
          height: "touchable",
          children: /* @__PURE__ */ jsx("div", { style: { width: "100px" } })
        }
      ),
      header: /* @__PURE__ */ jsx(
        Box,
        {
          background: "neutralLight",
          borderRadius: "large",
          style: { width: "55%", maxWidth: "100%" },
          children: /* @__PURE__ */ jsx(Heading, { component: "span", level: "1", children: " " })
        }
      ),
      headerAdditional: /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "large",
            style: { width: "80%", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { children: " " })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "large",
            style: { width: "80%", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { children: " " })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "large",
            style: { width: "55%", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { children: " " })
          }
        )
      ] }),
      mainContent: showMainContent && /* @__PURE__ */ jsx(Stack, { space: "large", children: [1, 1, 1].map(() => paragraph()) }),
      menu: /* @__PURE__ */ jsx("span", {}),
      jobTitle: "",
      companyName: ""
    }
  );
};
const JOB_DISPLAY_TYPE_QUERY_KEY = "type";
export {
  JOB_DISPLAY_TYPE_QUERY_KEY,
  JobDetailsMockup,
  JobDetailsPreview,
  JobDetailsView,
  useJobDetailsProps
};
